import React from 'react'
import { BtnV2, Icon, l, palettes } from '@manychat/manyui'

import { ButtonConfig } from 'apps/aiTextImprover/lib/types'
import { useKeyDown } from 'common/core/coreHooks'

import cm from './Button.module.css'

interface ButtonProps {
  value: string
  config: ButtonConfig
  onClick: (value: string) => void
}

export const Button = ({ value, config: { label, keyCode, icon }, onClick }: ButtonProps) => {
  const selectOption = () => {
    onClick(value)
  }

  useKeyDown({
    key: keyCode,
    onPress: selectOption,
  })

  const ButtonIcon = Icon[icon]

  return (
    <BtnV2
      data-test-id={`ai-text-improver/predefined-option-${value}`}
      onClick={selectOption}
      className={cm.button}
    >
      <span className={cm.button__content}>
        <span className={cm.button__label}>
          <ButtonIcon size={20} className="flex-shrink-0" color={palettes.semantic.primary} />

          <span className="text-ellipsis">{l.getString(label)}</span>
        </span>
      </span>
    </BtnV2>
  )
}
